import { FormAtylBase } from '../../form-atyl-base'

export class AtylRadio extends FormAtylBase<string> {
	controlType = 'radio'
	type: string
	options: any

	constructor(options: {} = {}) {
		super(options)
		this.type = options['type'] || []
		this.options = options['options'] || []
	}
}
